import React, { useCallback } from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

import Button from 'components/common/button';
import CreateCreditCardRequestComposition from 'actions/composition/create_credit_card_request_composition';
import { useExecuteAction } from 'components/hooks/connect_hooks';

const RequestPaymentButton = styled(Button)`
  background: transparent;
  border: none;
  color: inherit;
  height: 25px;
  padding: 0;
  width: 25px;
  &:focus {
    border: 1px solid grayLight;
    border-radius: 4px;
  }
  &:hover {
    background: transparent;
  }
`;

export default function CreditCardRequestButton() {
  const executeAction = useExecuteAction();
  const onClick = useCallback(() => executeAction(CreateCreditCardRequestComposition), []);

  return (
    <label className={'draftStylesMenu-item'} title={'Request credit card'}>
      <RequestPaymentButton className={classnames('fa fa-credit-card')} onClick={onClick} />
    </label>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/chat/credit_card_request_button.jsx